/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import rightOutlined from 'jimu-icons/svg/outlined/directional/right.svg';
const styles = css `
&.ds-item {
  height: 32px;
  .ds-item-label-container {
    max-width: calc(100% - 20px);
    .ds-item-label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 0;
    }
    .record-count {
      border-radius: 4px;
      color: var(--sys-color-action-text);
      background: var(--sys-color-action-hover);
      padding: 1px 4px 0px 4px;
      line-height: 16px;
      font-size: 12px;
    }
  }
}
`;
export default function RelatedSource(props) {
    const { label, count, onSelect, uiComponents } = props;
    const { Label, Button, Icon } = uiComponents;
    return jsx("div", { className: 'ds-item w-100 d-flex justify-content-between align-items-center', css: styles },
        jsx("div", { className: 'ds-item-label-container d-flex align-items-center' },
            jsx(Label, { className: 'ds-item-label ml-2', title: label }, label),
            jsx("div", { className: 'record-count ml-2' }, count !== null && count !== void 0 ? count : '...')),
        jsx(Button, { type: 'tertiary', size: 'sm', icon: true, disabled: !count, onClick: onSelect },
            jsx(Icon, { icon: rightOutlined, size: 16 })));
}
